export default function getDomainReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_DOMAIN_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_DOMAIN_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_DOMAIN_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}